import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { TAdminPools } from "../../Types";
import { post } from "../axios-post";
import { Ti18nKeys } from "../../constants/i18n";

export const apiCallGetAllAdminsPool = async (): Promise<{
  data: {
    adminApprovalPool: TAdminPools;
    adminReportPool: TAdminPools;
    adminInvestigationCasesPool: TAdminPools;
    adminAuditEventsPool: TAdminPools;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    adminApprovalPool: TAdminPools;
    adminReportPool: TAdminPools;
    adminInvestigationCasesPool: TAdminPools;
    adminAuditEventsPool: TAdminPools;
  }>(`auditor/getOtherAdminPool`, {});

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        adminApprovalPool: [],
        adminReportPool: [],
        adminInvestigationCasesPool: [],
        adminAuditEventsPool: []
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        adminApprovalPool: [],
        adminReportPool: [],
        adminInvestigationCasesPool: [],
        adminAuditEventsPool: []
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
